<template>
  <v-dialog v-model="showNewOrder" width="1200" persistent>
    <v-card>
      <div id="holder"></div>

      <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" md="3" lg="2" class="py-0 pt-5">
            <span class="white--text custom-title">{{ title }}</span>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pb-0">
            <p class="white--text"></p>
            <ValidationProvider
              name="Wholesaler"
              rules="required"
              v-slot="{ errors }"
            >
              <v-autocomplete
                :items="wholesalerData"
                label="Wholesaler"
                outlined
                placeholder="Select wholesaler"
                :error-messages="
                  !selectedWholeSaler ? 'Wholesaler is required' : errors
                "
                :error="!selectedWholeSaler"
                :item-text="setCompany"
                item-value="accountNumber"
                dense
                return-object
                dark
                v-model="selectedWholeSaler"
                :readonly="wholesalerData.length === 1"
                :disabled="isOriginal"
                @change="wholesalerChanged"
              ></v-autocomplete>
            </ValidationProvider>
            <v-spacer></v-spacer>
          </v-col>
        </v-row>
      </v-banner>

      <v-card-text class="pt-5 pb-8" ref="calcHeight">
        <v-row>
          <v-col
            cols="12"
            :md="orderType === 'nbn' ? '8' : '12'"
            class="pt-2 pb-0"
          >
            <div id="holder"></div>
            <qualification-form-5g
              v-if="isFeatureOn"
              ref="qualification"
              @showResultSection="showResultSection"
              @toggleInput="toggleInput"
              @changed="changed"
              @show5GResult="show5GResult()"
            ></qualification-form-5g>
            <qualification-result-5g
              ref="qualificationResult5g"
              class="mt-5"
              v-if="showResult"
              :showButtons="false"
              :hideOtherButtons="false"
              :showLocIdInput="showLocIdInput"
              :queryAddress="queryAddress"
              :hasMatch="hasMatch"
              :selected="selected"
              @serviceability="setServiceability"
              @hideBaseOffer="hideBaseOffer"
            ></qualification-result-5g>
          </v-col>
          <v-col cols="12" md="4" v-if="orderType === 'nbn'">
            <enhanced-sq></enhanced-sq>
          </v-col>
        </v-row>
      </v-card-text>

      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text class="pt-0">
          <v-divider class="mt-4 mb-8"></v-divider>

          <order-details
            v-if="showResult && hasSectorID"
            ref="orderDetails"
            :newOrder="newOrder"
            :ntd="ntd"
            :unid="unid"
            :wholesalerAccount="wholesalerAccount ? wholesalerAccount : 0"
            @createOffer="createOffer"
            @backToOffer="backToOffer"
            @emit5GData="set5GData"
            @updateContact="updateContact"
            @deliverToCustomer="setDeliveryDetails"
            @displayOffer="displayOffer"
            @updateWorkforce="updateWorkforce"
          ></order-details>
        </v-card-text>

        <div class="fixed-bar rtl primary py-4">
          <v-btn @click="close()" class="mr-4">Close</v-btn>
          <v-btn
            class="mr-3"
            :disabled="isOriginal || invalid || isProcessing || !isCustRefValid || !showResult || !hasSectorID || !selectedWholeSaler"
            @click="beforeCreateOrder()"
            >Create</v-btn
          >
        </div>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { Order } from "@/models/Order";
export default {
  name: "CreateOrder5G",
  props: {
    showNewOrder: { type: Boolean, required: true },
  },
  data: () => ({
    newOrder: new Order(),
    details: {},
    ntd: [],
    unid: [],
    queryAddress: [],
    showResult: false,
    showLocIdInput: false,
    newDate: null,
    showDetails: false,
    selectedWholeSaler: null,
    displaySection: false,
    sector: "",
    data5G: null,
    displayResult: false,
    isServiceable: false,
    workforceClass: ["23", "24", "30"],
    isContactValid: false,
    deliveryDetails: {
      address: "",
      name: "",
      company: "",
    },
    useCustomerDetails: true,
    isOfferVisible: false,
    installationClasses: ["23", "24", "32", "33", "34"],
    fttb: ["10", "11", "12", "13"],
    fttc: ["30", "31", "32", "33", "34"],
    primaryAccessTechnology: "",
    hasMatch: true,
    selected: "Physical Address",
    isProcessing: false,
  }),
  computed: {
    // hasInactive() {
    //   let vm = this;
    //   let inactiveCount = 0;
    //   vm.sqResult.parameters.parameterGroup.forEach((x) => {
    //     x.parameter.forEach((y) => {
    //       if (
    //         y.name === "Copper Pair Status" &&
    //         y.value.toLowerCase() === "inactive"
    //       )
    //         inactiveCount++;
    //     });
    //   });
    //   return inactiveCount > 0;
    // },
    invalidProductErr() {
      let vm = this;
      return vm.$route.path === "/"
        ? `${vm.primaryAccessTechnology} is not included in our services. Can't proceed with the order.`
        : `${vm.primaryAccessTechnology} is not included in our services.`;
    },
    isFttb() {
      let vm = this;
      if (vm.fttb.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    isFttc() {
      let vm = this;
      if (vm.fttc.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    isCustomWorkforce() {
      let vm = this;
      return vm.workforceClass.includes(
        vm.formattedSQResult.serviceabilityClass
      );
    },
    wholesalerAccount() {
      let vm = this;
      return vm.selectedWholeSaler ? vm.selectedWholeSaler.accountNumber : 0;
    },
    wholesalerData: function () {
      let vm = this;
      let data = null;

      if (vm.impersonating !== null) {
        if (vm.isAdmin) {
          data = vm.wholesalers;
          vm.selectedWholeSaler = null;
        } else {
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.user.email
          );

          if(data.length > 0) vm.selectedWholeSaler = data[0].accountNumber;
          else{
            if(vm.wholesalers.length === 1)
            {
              let userLoginIndex = vm.user.email.indexOf("@");
              let domain = vm.user.email.slice(userLoginIndex + 1);

              if(vm.wholesalers[0].oneLoginEmail.includes(domain))
              {
                data = vm.wholesalers;
                vm.selectedWholeSaler = data[0].accountNumber;
              }
            }
          }
        }
      } else {
        if (vm.isAdmin) {
          data = vm.wholesalers;

          if (vm.isOriginal)
            vm.selectedWholeSaler = vm.wholesalers.filter(
              (x) =>
                x.accountNumber === vm.selectedOrder.wholesalerAccountNumber
            )[0].accountNumber;
          else vm.selectedWholeSaler = null;
        } else {
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.user.email
          );
          vm.selectedWholeSaler = data[0].accountNumber;
        }
      }

      return data;
    },

    title() {
      let vm = this;
      if (vm.orderType === "nbn") return "Create NBN Order";
      else return "Create 5G Order";
    },
    is5G() {
      let vm = this;
      return vm.orderType === "5g";
    },
    isFeatureOn() {
      let vm = this;
      return vm.featureFlags && vm.featureFlags.connect5GSq;
    },
    sqNbnButtonState() {
      let vm = this;

      if (vm.isCustomWorkforce) {
        return (
          !vm.showDetails ||
          !vm.wholesalerAccount ||
          !vm.isServiceable ||
          !vm.isCustRefValid ||
          !vm.isContactValid ||
          !vm.isOfferVisible
        );
      } else
        return (
          !vm.showDetails ||
          !vm.wholesalerAccount ||
          !vm.isServiceable ||
          !vm.isCustRefValid ||
          !vm.isOfferVisible
        );
    },
    isCustRefValid() {
      let vm = this;
      return !vm.isDuplicate;
    },
    enableCreate() {
      let vm = this;
      return vm.hasSectorID && vm.wholesalerAccount && vm.isServiceable;
    },
  },
  methods: {
    validateForm(){
      let vm =this;
      
      vm.$nextTick(() => {
        vm.$refs.observer.validate();
      });
    },
    updateWorkforce(value) {
      let vm = this;
      vm.newOrder.installationWorkforce = value;
      vm.updateCustomizedOffer({
        field: "INSTALLATION_WORKFORCE",
        value: value,
      });
    },
    checkLayer() {
      const vm = this;
      if (vm.selectedWholeSaler && vm.orderType === "nbn") {
        vm.retrieveFeatures(vm.selectedWholeSaler.accountNumber);
      } else if (vm.selectedWholeSaler === null) {
        if (vm.wholesalers.length === 1)
          vm.retrieveFeatures(vm.wholesalers[0].accountNumber);
      }
    },
    retrieveFeatures(accountNumber) {
      let vm = this;
      vm.getFeatures(accountNumber);
    },
    wholesalerChanged() {
      let vm = this;
      vm.getUBCustomers({ id: vm.wholesalerAccount, keyword: "all" });
      if (vm.featureFlags.connect5GRetail && vm.wholesalerAccount === 61596)
        vm.get5gRatePlans(!vm.newOrder.isRetail);
      else vm.get5gRatePlans(true);

      vm.checkLayer();
    },
    displayOrder(item, sqResponse) {
      let vm = this;
      vm.showResult = true;
      vm.$nextTick(() => {
        vm.$refs.qualification.setAddress(item.address);
        vm.$refs.qualificationResult5g.displayOrder(item, sqResponse);
      });
    },
    
    displayOffer() {
      let vm = this;

      vm.isOfferVisible = true;
      if (vm.newOrder.installationWorkforce !== "Self Install")
        vm.isContactValid = true;
      else vm.isContactValid = false;
    },
    hideBaseOffer() {
      let vm = this;
      vm.isOfferVisible = false;
      vm.isServiceable = false;
    },
    setDeliveryDetails(value) {
      let vm = this;
      if (value) {
        vm.newOrder.deliveryAddress = vm.fullAddress.formatted_address;
        vm.newOrder.deliveryContactName = `${vm.newOrder.customerFirstName} ${vm.newOrder.customerLastName}`;
      }
    },
    updateContact(techDetails) {
      let vm = this;

      vm.newOrder.contactFirstName = techDetails.firstName;
      vm.newOrder.contactLastName = techDetails.lastName;
      vm.newOrder.contactNumber = techDetails.number;
      vm.newOrder.contactEmail = techDetails.email;
      vm.updateOfferContact(techDetails);
      vm.isContactValid = true;
    },
    show5GResult() {
      let vm = this;
      vm.showResult = true;
    },
    beforeCreateOrder() {
      const vm = this;
      let errorMessage = "";

      vm.$refs.observer.validate().then((result) => {
        if (!result) {
          errorMessage = "Please check highlighted fields";
          vm.setHttpResponse({
            text: errorMessage,
            color: "error",
          });
        } else {
          if (vm.is5G) {
            if (!vm.enableCreate) {
              errorMessage =
                "One or more values are missing. Please check highlighted fields, sector id, wholesaler account, or sq result";
            }
            if (!vm.isCustRefValid) {
              errorMessage = `${vm.newOrder.customerReference} already exist`;
            }
          } else {
            if (vm.sqNbnButtonState) {
              errorMessage = "Please check missing values";
            }
            if (
              vm.isFttb ||
              vm.installationClasses.includes(
                vm.formattedSQResult.serviceabilityClass
              )
            ) {
              if (vm.newOrder.installationWorkforce === "")
                errorMessage = "Please check missing values";
            }
            if (vm.newOrder.installationWorkforce === "Self Install") {
              if (!vm.isContactValid)
                errorMessage = "Technical contact is required";
            }
          }

          if (!errorMessage.length) {
            if (vm.is5G) vm.create5GOrder();
            else vm.createOrder();
          } else {
            vm.setHttpResponse({
              text: errorMessage,
              color: "error",
            });
          }
        }
      });
    },

    createOrder() {
      let vm = this;
      vm.isProcessing = true;
      vm.createNewOrder(vm.customizedOfferResult)
        .then((data) => {
          // if (data.success) {

          if (data !== null) {
            setTimeout(() => {
              vm.setCustomizedOffer({});
              vm.newOrder = new Order();
              vm.$emit("orderSubmitted");
              vm.setHttpResponse({
                text: `Order submitted and saved.`,
                color: "success",
              });
            }, 500);
          } else {
            setTimeout(() => {
              vm.setHttpResponse({
                text: `Failed. ${data.message}`,
                color: "error",
              });
            }, 500);
          }
        })
        .finally(() => {
          vm.isProcessing = false;
        });
    },
    setCompany(details) {
      let text = "";
      if (details.company !== "" && details.company !== null)
        text = details.company;
      else if (details.name !== "" && details.name !== null)
        text = details.name;
      return text;
    },
    setWholesaler() {
      let vm = this;
      vm.getWholesalers()
        .then((data) => {
          if (!vm.isUserMember || data.length === 1) {
            vm.selectedWholeSaler = data[0];
          } else vm.selectedWholeSaler = null;
        })
        .catch(() => {});
    },
    createOffer(order) {
      let vm = this;
      let payload = {
        locationId: vm.locationID,
        customerAuthDate: new Date(),
        orderType: order.orderType.value.toUpperCase(),
        requestedSpeed: order.avcdBandwidthProfile.value
          ? order.avcdBandwidthProfile.value
          : order.avcdBandwidthProfile,
        contractLength: order.contractTermLength,
        customer: {
          firstName: order.customerFirstName,
          lastName: order.customerLastName,
          contactNo: order.customerContactNumber,
          email: order.customerContactEmail,
        },
        ticketId: order.customerReference,
        customerAuthReference: order.customerAuthReference,
        operatorContactEmail: vm.user.email,
        operatorContactNumber: order.contactNumber,
        operatorContactName: `${order.contactFirstName} ${order.contactLastName}`,
        serviceId: "",
        accessLoopId: "N/A",
        fnn: order.fnn,
        wholesalerAccount: vm.wholesalerAccount,
      };

      vm.createCustomisedOffer(payload).then((data) => {
        if (data.data) {
          data.data.baseOffer.serviceFeatures.forEach((x) => {
            switch (x.featureKey) {
              case "NBN_SERVICE_SPEC:LOCATION_ID":
                vm.newOrder.locationId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:AVCD_BANDWIDTH_PROFILE":
                vm.newOrder.avcdBandwidthProfile =
                  x.value.value === "12/1"
                    ? "Entry Level Bundle"
                    : x.value.value;
                break;
              case "NBN_SERVICE_SPEC:RSP_DELIVERY_CIRCUIT":
                vm.newOrder.rspDeliveryCircuit = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_FIRST_NAME":
                vm.newOrder.customerFirstName = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_LAST_NAME":
                vm.newOrder.customerLastName = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_CONTACT_NUMBER":
                vm.newOrder.customerContactNumber = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_AUTH_DATE":
                vm.newOrder.customerAuthDate = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:UNIDSL_POTS_INTERCONNECT":
                vm.newOrder.unidslPotsInterconnect = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:SERVICE_CLASS":
                vm.newOrder.serviceClass = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_REFERENCE":
                vm.newOrder.customerReference = x.value.value;
                if (vm.isAdmin || vm.isUserMember)
                  vm.newOrder.customerAuthReference = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_AUTH_REFERENCE":
                if (!vm.isAdmin || !vm.isUserMember)
                  vm.newOrder.customerAuthReference = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CENTRAL_SPLITTER":
                vm.newOrder.centralSplitter = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:SPECIAL_INSTRUCTION":
                vm.newOrder.specialInstruction = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:PORTING_NUMBER":
                vm.newOrder.portingNumber = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CPI_ID":
                vm.newOrder.cpiId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:NTD_ID":
                vm.newOrder.ntdId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:INSTALLATION_WORKFORCE":
                if (vm.isCustomWorkforce)
                  vm.newOrder.installationWorkforce = "";
                else if (vm.isFttc) {
                  if (
                    vm.sqResult.parameters.parameterGroup &&
                    vm.sqResult.parameters.parameterGroup.length > 0
                  ) {
                    let cpi = vm.sqResult.parameters.parameterGroup.filter(
                      (x) => x.groupName === vm.newOrder.cpiId
                    );

                    if (cpi && cpi.length > 0) {
                      let cpiClass = cpi[0].parameter.filter(
                        (x) => x.name === "ServiceabilityClass"
                      )[0].value;

                      if (vm.fttc.includes(cpiClass)) {
                        if (cpiClass === "31" || cpiClass === "32")
                          vm.newOrder.installationWorkforce =
                            "Professional Install";
                        else vm.newOrder.installationWorkforce = "";
                      }
                    }
                  }
                } else if (vm.isFttb) {
                  vm.newOrder.installationWorkforce = x.value.value;
                  // if (
                  //   vm.formattedSQResult.serviceabilityClass === "11" ||
                  //   vm.formattedSQResult.serviceabilityClass === "12"
                  // )
                  //   vm.newOrder.installationWorkforce = "Professional Install";
                  // else if (
                  //   vm.hasInactive &&
                  //   vm.formattedSQResult.serviceabilityClass === "13"
                  // ) {
                  //   vm.newOrder.installationWorkforce = "Not Required";
                  // } else vm.newOrder.installationWorkforce = "";
                } else vm.newOrder.installationWorkforce = "Not Required";
                break;
              case "NBN_SERVICE_SPEC:CONTACT_NUMBER":
                vm.newOrder.contactNumber = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CONTACT_EMAIL":
                vm.newOrder.contactEmail = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:DELIVERY_INSTRUCTIONS":
                vm.newOrder.deliveryInstructions = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CSA_ID":
                vm.newOrder.csaId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:UNID_PORT_ID":
                vm.newOrder.unidPortId = x.value.value;
                break;
            }
          });

          // if (data.data.ordeR_TYPE === "SERVICE TRANSFER") {
          //   vm.newOrder.specialInstruction = "";
          //   vm.newOrder.portingNumber = "";
          // }

          vm.isOfferVisible = true;
          vm.showDetails = true;
        }
      });
    },
    set5GData(payload) {
      let vm = this;
      vm.setDeliveryDetails(payload.deliverToCustomer);
      vm.data5G = payload;
    },
    create5GOrder() {
      let vm = this;
      vm.data5G.WholesalerAccountNumber = vm.wholesalerAccount;
      vm.data5G.fullAddress = vm.fullAddress.formatted_address;
      vm.data5G.isWholesaler = !vm.data5G.isRetail;
      vm.data5G.ratePlanDescription = vm.ratePlans5G.filter(
        (x) => x.ratePlanID === vm.data5G.ratePlanID
      ).ratePlanDescription;
      vm.data5G.address = {
        streetAddress: vm.fullAddress.street_address,
        unitNumber: "",
        unitType: "",
        streetNumber: vm.fullAddress.street_number,
        streetName: vm.fullAddress.street_name,
        streetType: vm.fullAddress.street_type,
        streetSuffix: vm.fullAddress.street_suffix,
        suburb: vm.fullAddress.suburb,
        postCode: vm.fullAddress.postcode,
        state: vm.fullAddress.state,
        gNAFIdentifier: vm.fullAddress.gnaf_id,
      };

      vm.submit5GOrder(vm.data5G).then(() => {
        vm.getSimList("5G");
        if(vm.simList.length < 6) vm.sendAvailableSimEmail(vm.simList.length);
        vm.$emit("orderSubmitted");
      }).finally(() => vm.close());
    },
    backToOffer() {
      let vm = this;
      vm.showDetails = false;
      vm.newOrder.customerAuthDate = "";
      vm.newOrder.unidslPotsInterconnect = "";
      vm.newOrder.cpiId = "";
      vm.newOrder.ntdId = "";
      vm.newOrder.unidPortID = "";
      vm.newOrder.installationWorkforce = "";
      vm.newOrder.portingNumber = "";
      vm.newOrder.specialInstruction = "";
      vm.newOrder.deliveryInstructions = "";
    },
    close() { 
      let vm = this;
      document.getElementById("holder").scrollIntoView({ behavior: "smooth" });
      vm.$refs.observer.reset();
      vm.$refs.qualification.selected = "Physical Address";
      vm.newOrder = new Order();
      vm.resetFeature();

      if (vm.impersonating !== null) {
        if (vm.isUserMember) vm.selectedWholeSaler = null;
      } else {
        if (vm.isAdmin) vm.selectedWholeSaler = null;
      }

      vm.$refs.qualification.streetAddress = "";
      vm.$refs.qualification.result = {
        suburb: "",
        state: "",
        postCode: "",
        streetAddress: "",
      };
      vm.queryAddress = [];
      vm.showResult = false;
      vm.$emit("close");
      vm.reset5gSq();
      vm.resetHasSectorId();
      vm.sector = "";
      vm.setOriginal(false);
      vm.resetProduct();
      vm.resetAddressResults();  
    },
    showResultSection(data) {
      let vm = this;
      vm.showResult = true;

      if (vm.orderType === "nbn") {
        if (vm.selected === "Physical Address") {
          vm.hasMatch =
            data.result.addresses && data.result.addresses.length > 0;
        }

        vm.queryAddress = data.queryAddress;
        if (data.queryAddress.length === 1 && data.queryAddress.length !== 0) {
          vm.setLocationID(data.queryAddress[0].locationId);
          vm.showLocIdInput = false;
          vm.serviceQualification(data.queryAddress[0]).then((result) => {
            let value = true;

            result.data.parameters.parameter.forEach((x) => {
              if (x.name === "PrimaryAccessTechnology")
                vm.primaryAccessTechnology = x.value;
            });

            vm.getExcludedProducts(vm.primaryAccessTechnology).then(() => {
              if (vm.isProductExcluded) {
                vm.setHttpResponse({
                  text: vm.invalidProductErr,
                  color: "error",
                });
              }
            });

            if (
              vm.sqResult.serviceability.includes("Rejected") ||
              vm.isProductExcluded
            )
              value = false;
            vm.setServiceability(value);
            vm.setFormattedSQResult(result.data);
            vm.displayResult = true;
            this.$nextTick(() => {
              vm.$refs.qualificationResult5g.result = result.data;
              vm.$refs.qualificationResult5g.showSqResult = true;
            });
          });
        } else vm.showLocIdInput = true;
      } else {
        if (vm.selected === "Physical Address") {
          vm.hasMatch = vm.sq5gResult.location.length > 0;
        }
        vm.setDeliveryDetails(true);
        this.$nextTick(() => {
          vm.$refs.qualificationResult5g.showSqResult = true;
        });
        vm.validateForm();
      }
    },
    toggleInput(state) {
      let vm = this;
      vm.showResult = state;
      vm.showLocIdInput = state;
    },
    setNewDate(date) {
      let vm = this;
      vm.setNewDate = date;
    },
    changed(selected) {
      let vm = this;
      vm.showResult = false;
      vm.showLocIdInput = false;
      vm.queryAddress = [];
      vm.hasMatch = true;
      vm.resetFormattedSQResult();
      vm.newOrder.ratePlanID = 0;
      if (vm.orderType === "5g") vm.newOrder.orderType = "Add";
      if (selected !== undefined) {
        vm.selected = selected;
      }
    },
    setServiceability(value) {
      let vm = this;
      vm.isServiceable = value;
    },
  },
  watch: {
    details: function () {
      let vm = this;
      let hasLotNumber = false;

      if (vm.details.address.formattedAddress.includes("Lot"))
        hasLotNumber = true;

      let streetAddress = vm.details.address.formattedAddress.split(",");

      vm.$nextTick(() => {
        vm.$refs.qualification.result = {
          suburb: vm.details.address.suburb,
          state: vm.details.address.stateOrProvince,
          postCode: vm.details.address.postcode,
          streetAddress: hasLotNumber
            ? streetAddress[0] + ", " + streetAddress[1]
            : streetAddress[0],
        };
        vm.$refs.qualification.withData = vm.details.withData;
      });
    },
    locationID: function () {
      let vm = this;
      vm.newOrder = new Order();
      if (vm.orderType === "5g") vm.newOrder.orderType = "Add";
      vm.resetProduct();
    },
    wholesalerAccount: function () {
      let vm = this;
      if (vm.wholesalerAccount) {
        if (
          typeof vm.$refs.orderDetails !== "undefined"
        )
          vm.updateCustomizedOffer({
            field: "Wholesaler",
            value: vm.wholesalerAccount,
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-padding .v-banner__wrapper {
  padding-bottom: 0px !important;
}

.custom-title {
  font-size: 20px;
  font-weight: bold;
}

.rtl {
  direction: rtl;
}

.fixed-bar {
  width: 100%;
  position: sticky;
  bottom: -1px;
}

::v-deep
  .fixed-bar
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #f5f5f5 !important;
}
</style>
